import React, { useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import QRCode from '../../components/QRCode';
import { useGetMyProfile } from '../../services/mutations';
import {
  localStorageKeys,
  localStorageUserType,
  useLocalStorage,
} from '../../utils/localStorageItems';

const ClubMembershipCard = () => {
  const getMyProfile = useGetMyProfile();
  const localStorageItem = useLocalStorage();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    getMyProfile.mutate(
      {},
      {
        onSuccess: (response) => {
          setProfile(response?.data?.payload);
        },
      },
    );
  }, []);

  const fullName = useMemo(
    () =>
      [profile?.user?.first_name, profile?.user?.last_name]
        .filter(Boolean)
        .join(' '),
    [profile],
  );
  const profileId =
    profile?.id ||
    localStorageItem.getLocalStorageItem(localStorageKeys.profileId) ||
    '';
  const roleLabel =
    localStorageItem.getLocalStorageItem(localStorageKeys.userType) ===
    localStorageUserType.dater
      ? 'DATER'
      : 'FRIEND';

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        marginTop: '80px',
        pb: 9,
        px: 3,
        background: '#000',
        display: 'flex',
        justifyContent: 'center',
      }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 520,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: '#fff',
          pt: 4,
          textAlign: 'center',
        }}>
        <Box
          sx={{
            color: '#9b9b9b',
            fontSize: 22,
            letterSpacing: 8,
            mb: 4,
          }}>
          MEMBER CARD
        </Box>
        <Box
          sx={{
            background: '#fff',
            borderRadius: '22px',
            lineHeight: 0,
            width: 328,
            height: 328,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}>
          {profileId ? (
            <QRCode value={profileId} size={328} />
          ) : (
            <Box
              sx={{
                color: '#000',
                fontSize: 18,
                fontWeight: 700,
                lineHeight: 1.2,
                px: 2,
              }}>
              Loading membership card
            </Box>
          )}
        </Box>
        <Box
          sx={{
            mt: 5,
            fontSize: 38,
            fontWeight: 800,
            lineHeight: 1.1,
          }}>
          {fullName || 'Club Meadow Member'}
        </Box>
        <Box
          sx={{
            color: '#9b9b9b',
            fontSize: 22,
            letterSpacing: 2,
            mt: 1.5,
          }}>
          {roleLabel}
        </Box>
        <Box
          sx={{
            color: '#cfcfcf',
            fontSize: 30,
            lineHeight: 1.25,
            mt: 6,
          }}>
          Show this code at the door
          <br />
          for entry to any Meadow event
        </Box>
      </Box>
    </Box>
  );
};

export default ClubMembershipCard;
